export default "/assets/images/highway-pollution-video-thumbnail.jpg?884d8014f1807983095fca26e55f027e";